import { Injectable } from '@angular/core'
import { SeOverlayOptions } from './overlay-options'
import { StyleLoaderService } from './../core/style-loader/style-loader.service'
import { SeOverlay } from './overlay'

@Injectable({providedIn: 'root'})
export class SeOverlayService {

  private animationDuration: number = 0

  constructor(private styleLoaderService: StyleLoaderService) {
    // noop
  }

  public create(options?: SeOverlayOptions): SeOverlay {
    this.initAnimationDuration()
    return new SeOverlay(options, this.animationDuration)
  }

  private initAnimationDuration(): void {

    if (this.animationDuration) {
      return
    }

    this.animationDuration = this.styleLoaderService.getVariable('se-overlay-animation-duration').value

  }

}
